export type ComingSoonTrafficSource = 'meta' | 'tiktok' | 'mgid' | 'revcontent';

export interface ComingSoonTrafficSourceConfig {
    logoPath: string;
    logoAlt: string;
    displayNameKey: string;
}

export const COMING_SOON_TRAFFIC_SOURCE_CONFIG: Record<ComingSoonTrafficSource, ComingSoonTrafficSourceConfig> = {
    meta: {
        logoPath: 'assets/icone/rede_ads/meta-ads.png',
        logoAlt: 'Meta Ads',
        displayNameKey: 'menu.nav.metaAds',
    },
    tiktok: {
        logoPath: 'assets/icone/rede_ads/tiktok-ads.png',
        logoAlt: 'TikTok Ads',
        displayNameKey: 'menu.nav.tiktokAds',
    },
    mgid: {
        logoPath: 'assets/icone/rede_ads/mgid-ads.svg',
        logoAlt: 'MGID',
        displayNameKey: 'menu.nav.mgidAds',
    },
    revcontent: {
        logoPath: 'assets/icone/rede_ads/revcontent-ads.svg',
        logoAlt: 'RevContent',
        displayNameKey: 'menu.nav.revcontentAds',
    },
};
